import React, { useEffect, useState } from 'react';
import { AiOutlineDelete } from "react-icons/ai";

const PageRangeSelector = ({ pageRange, setPageRange }) => {
  const [pageRanges, setPageRanges] = useState(
    pageRange === "All Pages" ? (
      [{ type: 'single', start: 1, end: null }]
    ) : (
      pageRange.split(';').map(range => {
        const [start, end] = range.split('-');
        return { type: end ? 'range' : 'single', start: parseInt(start), end: end ? parseInt(end) : null };
      })
    ) || [{ type: 'single', start: 1, end: null }]
  );

  useEffect(() => {
    if (pageRange !== "All Pages") {
      setPageRange(pageRanges.map(range => range.type === 'single' ? range.start : `${range.start}-${range.end}`).join(';'));
    }
  }, [pageRange, pageRanges, setPageRange]);

  const handlePageRangeTypeChange = (e) => setPageRange(e.target.value);

  const handleRangeChange = (index, key, value) => {
    const updatedRanges = [...pageRanges];
    updatedRanges[index][key] = value;
    setPageRanges(updatedRanges);
  };

  const addNewRange = () => {
    setPageRanges([...pageRanges, { type: 'single', start: 1, end: null }]);
  };

  const removeRange = (index) => {
    const updatedRanges = pageRanges.filter((_, i) => i !== index);
    setPageRanges(updatedRanges);
  };

  return (
    <div className='mb-6'>
      <div className="flex items-center space-x-4">
        <label>
          <input
            type="radio"
            value="All Pages"
            className="mr-2"
            checked={pageRange === "All Pages"}
            onChange={handlePageRangeTypeChange}
          />
          All Pages
        </label>
        <label>
          <input
            type="radio"
            value=""
            className="mr-2"
            checked={pageRange !== "All Pages"}
            onChange={handlePageRangeTypeChange}
          />
          Specific Pages
        </label>
      </div>

      {pageRange !== "All Pages" && (
        <div className="mt-2">
          {pageRanges.map((range, index) => (
            <div className='flex items-center space-x-2' key={index}>
              <div className="flex items-center space-x-2 mb-2 border p-2">
                <select
                  value={range.type}
                  onChange={(e) => handleRangeChange(index, 'type', e.target.value)}
                  className="border p-1"
                >
                  <option value="single">Single Page</option>
                  <option value="range">Page Range</option>
                </select>

                {range.type === 'single' ? (
                  <input
                    type="number"
                    min={1}
                    value={range.start}
                    onChange={(e) => handleRangeChange(index, 'start', e.target.value)}
                    className="border p-1 w-24"
                    placeholder="Page"
                  />
                ) : (
                  <>
                    <input
                      type="number"
                      min={1}
                      value={range.start}
                      onChange={(e) => handleRangeChange(index, 'start', e.target.value)}
                      className="border p-1 w-24"
                      placeholder="Start Page"
                    />
                    <span>to</span>
                    <input
                      type="number"
                      min={range.start}
                      value={range.end || ''}
                      onChange={(e) => handleRangeChange(index, 'end', e.target.value)}
                      className="border p-1 w-24"
                      placeholder="End Page"
                    />
                  </>
                )}
                
              </div>
              <button type="button" onClick={() => removeRange(index)} className="text-red-500 font-bold ml-3">
                <AiOutlineDelete size={20} />
              </button>
            </div>
          ))}
          <button type="button" onClick={addNewRange} className="bg-blue-500 text-white px-2 py-1 rounded mt-2">
            + Add New Page/Range
          </button>
        </div>
      )}
    </div>
  );
};

export default PageRangeSelector;
